export function traNavTabs(active: 'waitlist' | 'editions' | 'members' | 'stats') {
  return [
    { label: 'Lista de espera', to: '/tra/waitlist', active: active === 'waitlist' },
    { label: 'Ediciones', to: '/tra/editions', active: active === 'editions' },
    { label: 'Miembros certificados', to: '/tra/members', active: active === 'members' },
    { label: 'Estadísticas', to: '/tra/stats', active: active === 'stats' },
  ];
}
